import { DefaultImages } from '@ifit/img/out/defaults';
import { getResizedImageUrl } from '../../util/get-resized-image-url';

export const paramountImageSize = {
  mobile: {
    width: 684,
    height: 656,
  },
  tablet: {
    width: 1326,
    height: 720,
  },
};

export function getParamountImageSized(url: string, deviceType: string): string {
  return getResizedImageUrl(url, DefaultImages.Hero, paramountImageSize[deviceType]);
}
